<template>
	<div :class="contraer ? 'col-md-3 sidebar' : 'col-md-2 sidebar'">
		<div class="row">
			<div class="col-md-12">
				<a class="contraer" @click="control"><i class="fas fa-bars fa-fw fa-lg" /></a>
			</div>
		</div>
		<p></p>
		<div class="row">
			<div class="col-md-12">
				<select v-model="opcion" class="form-control opciones" @change="seleccionaOpcion">
					<option value=""></option>
					<option value="carga15">Cargar archivo de 15 días</option>
					<option value="carga30">Cargar archivo de 30 días</option>
					<option value="emitidos">Documentos Emitidos</option>
					<option value="diferencias">Diferencias Docs y O. facturación</option>
				</select>
			</div>
		</div>
		<p></p>
		<div class="row">
			<div class="col-md-12">
				<input id="busquedas" class="form-control" type="text" placeholder="Filtro..." v-model="busqueda">
			</div>
		</div>
		<p></p>
		<div class="row">
			<div class="col-md-12 text-left">{{ fichas ? fichas.length : 0 }} Grupos</div>
		</div>
		<div class="row" id="fichas">
			<div class="col-md-12" v-for="(ficha, index) in buscar" :key="index">
				<ficha :data="ficha" :id="index" :on-facturar="onFacturar"></ficha>
			</div>
		</div>
	</div>
</template>
<script lang="ts">

	import axios from "axios"
	import $ from "jquery"
	import Ficha from "./ficha.vue"


	export default {
		name: "Sidebar",
		components: { Ficha },
		props: {
			onContraer: Function,
			onAccion: Function,
		},
		data() {
			return {
				periodo: "",
				opcion: "",
				busqueda: "",
				contraer: true, // Variable que controla la accion del boton expandir/contraer del panel
				fichas: [],
			}
		},
		created() { 

			this.periodo = this.$periodo
		},
		mounted: function() {

			// Guardamos el THIS en otra variable para poder usarla aqui. No se puede usar directamente THIS en esta parte del ciclo de vida (?????)
			const that = this

			// Escuchamos por el evento "cambio-periodo", que se genera desde el componente HEADER y lo envia a todos los componentes activos 
			// Actualizamos las fichas
            window.event.$on("evento-cambio-periodo", function(periodo) {

				that.periodo = periodo
            })

			this.leerFichas()

		},
		computed: {

			buscar() {

				return !this.fichas ? [] :  this.fichas.filter((ficha) => { return ficha.name.toLowerCase().includes(this.busqueda.toLowerCase()) })
			},
		},
		methods: {

			// Metodo para contraer/expandir el panel sidebar
			control() {

				// Cambiamos el estado de la variable para la proxima ejecucion
				this.contraer = !this.contraer

				// Llamamos a la funcion callback asociada a la accion de contraer/expandir la barra lateral
				if (this.onContraer)
					this.onContraer(this.contraer)
            },

			// Genera el evento para actualizar el panel de acuerdo a la opcion seleccionada en el combobox
			seleccionaOpcion() {

				if (this.opcion == "")
					return

				if (this.onAccion)
					this.onAccion(this.opcion, "")
			},

			// Metodo para leer las Fichas
            leerFichas() {

				// Limpiamos el arreglo
                this.fichas = [];

                // Llamamos al WS para traer las fichas a mostrar
				var request = {
                    "usuario": this.$usuario, // variable global que guarda el usuario a usar en la llamada al ws
                    "destino": this.$env,
                    "tx": "F0",
                    "periodo": this.periodo.substr(0, 7), // cortamos el dia del periodo, para enviar solo YYYY-MM
                    "proceso": "stats",
                }

				// Llamada a la API
				axios.post("/face", request, { headers: { "Content-Type": "text/plain" }}).then(response => {

					// Asignamos la respuesta de la llamada al arreglo de fichas para mostrarlas en pantalla
					this.fichas = response.data.data.fichas;

				}).catch(ex => { console.log(ex.message) })
            },

			onFacturar(accion, info) {

				$(".ficha").removeClass("ficha-activa")
				$("#ficha_" + info.replace(" ", "_")).addClass("ficha-activa")

				if (this.onAccion)
					this.onAccion(accion, info)
			}
		}
	}

</script>
<style scoped>

	.sidebar {
		padding-top: 10px;
	}

	.contraer {
		text-decoration: none;
		color: black;
	}

	.contraer:hover {
		opacity: 0.6;
		cursor: pointer;
	}

	.opciones {
		font-size: 14px;
	}

	#busquedas {
		font-size: 12px;
	}

    #fichas {
        margin: 0px;
		margin-top: 5px;
    }

</style>
